"use client";

import { useState } from "react";

interface SearchBarProps {
  placeholder?: string;
  defaultValue?: string;
  onChange: (query: string) => void;
}

export function SearchBar({
  placeholder = "物件名や住所などで絞り込み",
  defaultValue = "",
  onChange,
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className="mb-6">
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full border border-border rounded-full px-5 py-2.5 text-sm focus:outline-none focus:border-accent"
      />
    </div>
  );
}
